import { render } from "./FabWrapper.vue?vue&type=template&id=e5bca6b0"
import script from "./FabWrapper.vue?vue&type=script&lang=js"
export * from "./FabWrapper.vue?vue&type=script&lang=js"

import "./FabWrapper.vue?vue&type=style&index=0&id=e5bca6b0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/components/FabWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5bca6b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5bca6b0', __exports__)) {
    api.reload('e5bca6b0', __exports__)
  }
  
  module.hot.accept("./FabWrapper.vue?vue&type=template&id=e5bca6b0", () => {
    api.rerender('e5bca6b0', render)
  })

}


export default __exports__